import {asyncType} from '../helpers';

export const licenseKey = 'license';

export default {
   GET_LICENSE: asyncType(`${licenseKey}/GET_LICENSE`),
   GET_LICENSE_OPTIONS: asyncType(`${licenseKey}/GET_LICENSE/GET_LICENSE_OPTIONS`),
};
